import { Logo } from 'assets/img';
import Image from 'next/image';

const LogoLarge = ({ width = '150px', height = '55px' }) => (
  <Image src={Logo} alt="Logo-hungerhub" layout="fixed" width={width} height={height} />
);

export default LogoLarge;
